module.exports = __webpack_public_path__ + "img/content-1.ad14baa6.png";